<div class="card">
  <div class="grid">
    @for (count of [].constructor(count); track count) {
      <div [ngClass]="getColumnClass()">
        <div class="p-field">
          <p-skeleton width="100px" height="1.5rem"></p-skeleton>
          <p-skeleton width="100%" height="2rem"></p-skeleton>
        </div>
      </div>
    }
  </div>
</div>